export default __webpack_public_path__ + "static/media/1_9_logo.acb40fda.png";